import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

export class ReportsService {
    constructor(private COLUMN_FILTER) {}

    getDateRange(type: 'end' | 'start'): string {
        if (type === 'end') {
            return moment().utc().toISOString();
        }
        if (type === 'start') {
            return moment()
                .subtract(this.COLUMN_FILTER.INITIAL.PAST_DAYS, 'days')
                .hour(6)
                .minute(0)
                .second(0)
                .millisecond(0)
                .utc()
                .toISOString();
        }
    }
}

angular.module('app').service('reportsService', ReportsService);
